import _ from "lodash"
import { common, responsiveCSSStyle } from "./styles"

/**
 * Custom chart's general options
 * See API doc: https://api.highcharts.com/highstock/chart
 * @param chartOpts
 * @returns {*}
 */
export default function chartPlugin(chartOpts) {
  _.unset(chartOpts, "chart.resetZoomButton")
  _.unset(chartOpts, "chart.options3d")
  _.unset(chartOpts, "chart.title")
  _.unset(chartOpts, "chart.borderWidth")
  _.unset(chartOpts, "chart.borderColor")
  _.unset(chartOpts, "chart.paddingBottom")
  _.unset(chartOpts, "chart.paddingTop")
  _.unset(chartOpts, "chart.plotShadow")
  _.unset(chartOpts, "chart.plotBackgroundColor")
  _.unset(chartOpts, "chart.plotBackgroundImage")
  _.unset(chartOpts, "chart.plotBorderWidth")
  _.unset(chartOpts, "chart.plotBorderColor")

  _.set(chartOpts, "chart.height", 480)
  _.set(chartOpts, "chart.backgroundColor", common.white)
  _.set(chartOpts, "chart.borderWidth", 0)
  _.set(chartOpts, "chart.style", responsiveCSSStyle())
  return chartOpts
}
